import { useScriptMode } from "../../../../contexts/ScriptModeContext";
import { ACTIVITY_LABEL_KEYS, unitWord } from "../../../goals/goalRules";
import { soft } from "./softClasses";

/**
 * Sıralama satırının altında açılan hedef dökümü: sıralamayla aynı dönemde
 * kardeşin her hedefi için ince çizgili bir satır (ad, biçim rozeti, ince
 * çubuk, "değer / hedef birim" ve oran). Veri get-group-progress yanıtındaki
 * members[i].goals'tan gelir, ayrıca sorgu yapılmaz. Biçimi olmayan eski
 * hedef okuma sayılır (mobil activityBadge gibi).
 */
export default function MemberGoalBreakdown({ goals }) {
  const { t } = useScriptMode();
  const list = Array.isArray(goals) ? goals : [];

  if (!list.length) {
    return <p className={`pl-12 pr-5 py-3 text-xs ${soft.muted}`}>{t("Hedef yok")}</p>;
  }

  return (
    <ul className="bg-terakkiBrandCloud/40 dark:bg-white/[0.03]" data-testid="member-goals">
      {list.map((g, i) => {
        const rate = Math.round(Number(g.completionRate) || 0);
        const unit = g.unit ? ` ${unitWord(g.unit, t)}` : "";
        const activityKey = ACTIVITY_LABEL_KEYS[g.activity] || ACTIVITY_LABEL_KEYS.okuma;
        return (
          <li
            key={`${g.label}-${g.activity || "okuma"}-${i}`}
            className="flex flex-col gap-1 pl-12 pr-5 py-2 border-b border-terakkiBorder dark:border-white/15"
          >
            <span className="flex items-baseline gap-3 min-w-0">
              <span className="flex-1 min-w-0 flex items-baseline gap-2">
                <span className={`min-w-0 text-[13px] truncate ${soft.ink}`}>{g.label}</span>
                <span
                  data-testid="goal-activity"
                  className={`shrink-0 px-2 py-px rounded-full text-[10px] leading-4 ${soft.chip} ${soft.muted}`}
                >
                  {t(activityKey)}
                </span>
              </span>
              <span className={`shrink-0 text-[11px] tabular-nums ${soft.muted}`}>
                {`${g.value ?? 0} / ${g.goalValue ?? 0}${unit}`}
              </span>
              <span className={`shrink-0 w-10 text-right text-[13px] tabular-nums ${soft.accent}`}>%{rate}</span>
            </span>
            <span className={soft.track}>
              <span className={`block ${soft.fill}`} style={{ width: `${Math.min(100, Math.max(0, rate))}%` }} />
            </span>
          </li>
        );
      })}
    </ul>
  );
}
